import React, { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const Scorebar = ({ score }) => {
  const { translatedLabels } = useContext(GlobalContext);
  const screenLabels = translatedLabels?.common;

  const scores = Array.from({ length: 10 }, (_, i) => i + 1);

  const validScore = Math.min(Math.max(score, 1), 10);
  return (
    <>
      <div className="score-bar-container">
        <div className="labels">
          <span>{screenLabels?.low?.label_value || "Low"}</span>
          <span>{screenLabels?.normal?.label_value || "Median"}</span>
          <span>{screenLabels?.high?.label_value || "High"}</span>
        </div>

        <div className="score-bar">
          {scores.map((num) => (
            <div
              key={num}
              className={`score-segment ${num === validScore ? "active" : ""}`}
            >
              {num === validScore && <div className="marker"></div>}
            </div>
          ))}
        </div>

        <div className="score-numbers">
          {scores.map((num) => (
            <span key={num}>{num}</span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Scorebar;
